export enum Platform {
  WEB = "web",
  MWEB = "mweb",
}
interface initServerHostType {
  serverHost?: string;
  apiDomain: string;
}
export interface CommonRuntime {
  // request 基础信息
  hostname: string;
  pathname: string;
  userAgent: string;
  cookie: string;
  cookies: { [key: string]: string };
  // tights page 基础信息
  version: string;
  id: string;
  // 网站 基础信息
  platform: Platform;
  isUat: boolean;
  countryCode3: string;
  languageCode: string;
  currency: string;
  isInApp: boolean;
  // 额外
  countryCode2?: string;
  appKey: string;
  appSecret: string;
  sid: string;
  sessionKey: string;
  multiLanImgKey?: string;
  priceGraph?: string;
  countryId?: string;
  initServerHost: initServerHostType; // server 端 IP / apiDomain 存储
  client: string;
  __cust: string;
}

let Runtime: Partial<CommonRuntime> = {};

export function setRuntime(runtime: CommonRuntime) {
  Runtime = runtime;
}

export function getRuntime(): Partial<CommonRuntime> {
  return Runtime;
}

export function getMeta(runtime: CommonRuntime) {
  const { countryCode3, languageCode, client, currency } = runtime;
  return {
    catalog: countryCode3,
    lang: languageCode,
    client,
    priceSymbol: currency,
  };
}
